import QuickView from './product/quickView';
import ProductBox from './product/productBox';

document.addEventListener('DOMContentLoaded', () => {
    const p = new ProductBox();
    p.run();
    const quickView = new QuickView();
    quickView.run();
});
